import React, { useState } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'
import css from 'styled-jsx/css'

import { ChildProps } from '~/common/define/props'
import { addClass } from '~/common/utils/html'
import { GeneralIconTag } from '~/common/define/icon'
import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import Icon, { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'

interface Props extends ChildProps {
  color: SpaceColor
  open: boolean
  onClickKnob(): void
}

const Navigation = ({children, color, open, onClickKnob}: Props) => {
  const [isShowingNavi, setIsShowingNavi] = useState<boolean>(false)
  const isOpeningNavi = open || isShowingNavi

  const {className: colorClass, styles: colorStyles} = css.resolve`
    div { background: ${lightenColor(color, ColorWeight.FEATHER)};
  }`

  return (
    <nav className={styles.wrap + addClass(styles.open, open) + addClass(styles.close, !open)}
           onMouseLeave={() => setIsShowingNavi(false)}
    >
      <div className={styles.navigation + addClass(colorClass)
        + addClass(isOpeningNavi ? styles.navigation__open : styles.navigation__close)
        + addClass(styles.navigation__shadow, isShowingNavi && !open)}
      >
        {children}
        {colorStyles}
        <style jsx>{`
          span:hover {
            background: ${lightenColor(color, ColorWeight.LIGHT)};
          }
       `}</style>
        <span className={styles.navigation__show} onMouseEnter={() => setIsShowingNavi(true)}>
          <Icon tag={GeneralIconTag.DRAGGABLE} size={IconSize.M_SMALL} fillColor={color}/>
        </span>
      </div>
      <div className={styles.knob + addClass(isOpeningNavi ? styles.knob__open : styles.knob__close)}>
        <button onClick={onClickKnob}>
          <Icon tag={open ? GeneralIconTag.OPEN_NAVI : GeneralIconTag.CLOSE_NAVI} frame={IconFrame.CIRCLE}
                fillColor={IconColor.WHITE} bgColor={color} clickableColor={color}
          />
        </button>
      </div>
    </nav>
  )
}

export default Navigation